"use client";
import {
  bottomToToptextStagger,
  bottomToToptextStaggerChildren,
} from "@/commonComponents/animations";
import ArrowBannerBackground, {
  ArrowBannerBackgroundProps,
} from "@cc/arrow-banner-background";
import ReactiveBreadcrumb from "@/commonComponents/breadcrumb";
import {
  MotionStack,
  MotionTypography,
} from "@/commonComponents/motion-components";
import SectionWrapper from "@/commonComponents/section-wrapper";
import { isArray } from "lodash";
import { StaticImageData } from "next/image";

export type AboutUsBannerProps = {
  data: {
    title: string;
    images: ArrowBannerBackgroundProps["images"] | string | StaticImageData;
  };
};

const AboutUsBanner = (props: AboutUsBannerProps) => {
  const { title, images } = props.data;
  return (
    <SectionWrapper
      SectionProps={{
        sx: {
          background: (theme) =>
            `${theme.palette.gradient.transparentToDarkRight}, ${
              images &&
              !isArray(images) &&
              (typeof images === "string" || "src" in images)
                ? `url(${typeof images === "string" ? images : images.src})`
                : ""
            } no-repeat`,
          position: "relative",
          backgroundSize: "cover !important",
        },
      }}
      py={{ xs: 2, md: 4 }} //Todo: basePy
      pb={{ xs: 3, md: 8 }}
      minHeight={{ xs: 372, md: 410, xl: 458 }}
    >
      <ReactiveBreadcrumb />
      {isArray(images) && (
        <ArrowBannerBackground
          images={images as ArrowBannerBackgroundProps["images"]}
        />
      )}
      <MotionStack
        mt={"auto"}
        maxWidth={1028}
        rowGap={3}
        variants={bottomToToptextStagger(0.6)}
        initial={"initial"}
        animate={"animate"}
      >
        <MotionTypography
          variant="h1"
          variants={bottomToToptextStaggerChildren}
        >
          {title}
        </MotionTypography>
      </MotionStack>
    </SectionWrapper>
  );
};

export default AboutUsBanner;
